
export default {
    changeInfoInit: 'persons/change-infos/init',
    default: 'persons',
    paramId: 'persons/:id',
    search: 'persons/search',
    preview: 'persons/:id/preview',
    paging: 'persons/paging',
    quickSearch: 'persons/quicksearch',
    quickLinks: 'persons/:id/quick-links',
    smartSuggestion: 'persons/smart-suggestion',
    token2Condition: 'persons/populate-condition/token2Detail',
    condition2Token: 'persons/populate-condition/detail2Token',
    relationById: 'persons/:personid/relation/:id',
    relation: 'persons/relation',
    proposal: 'persons/:id/proposal',
    property: 'persons/:id/properties',
    demand: 'persons/:id/proposal-demand',
    history: 'persons/:id/histories',
    configuration: 'persons/configs',
    getQuickSearchPersons: 'persons/quicksearch?text=:ids&type=ids',
    loadContentByTabName: 'persons/:id/load-tab/:tab',
    mergePerson: 'persons/merge',
    personRelation: '/persons/:id/relations',
    deleteAll: '/persons/delete-all'
}